module.exports = __webpack_public_path__ + "static/media/Background_Mexico_City.c40babbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Background_Mexico_City.jpg
// module id = 70
// module chunks = 0